import { useMemo } from "react";

import { BackEndPlatformTypes } from "types";

const useBackendPlatform = backendPlatformType => {
	const isBackEndPlatformOmaha = useMemo(() => {
		return backendPlatformType === BackEndPlatformTypes.Omaha.name;
	}, [backendPlatformType]);

	const isBackEndPlatformNorth = useMemo(() => {
		return backendPlatformType === BackEndPlatformTypes.North.name;
	}, [backendPlatformType]);

	const isBackEndPlatformTsys = useMemo(() => {
		return backendPlatformType === BackEndPlatformTypes.Tsys.name;
	}, [backendPlatformType]);

	const isBackEndPlatformOther = useMemo(() => {
		return backendPlatformType === BackEndPlatformTypes.Other.name;
	}, [backendPlatformType]);

	const isBackEndPlatformStraddle = useMemo(() => {
		return backendPlatformType === BackEndPlatformTypes.Straddle.name;
	}, [backendPlatformType]);

	return {
		isBackEndPlatformOmaha,
		isBackEndPlatformNorth,
		isBackEndPlatformTsys,
		isBackEndPlatformOther,
		isBackEndPlatformStraddle,
	};
};

export default useBackendPlatform;
